export default __webpack_public_path__ + "static/media/reset-password-v2.477a1e51.svg";